// extracted by mini-css-extract-plugin
module.exports = {"paper":"RecentNotesBar_paper__cJ273"};